import { render } from "./TierItem.vue?vue&type=template&id=2a349916&scoped=true"
import script from "./TierItem.vue?vue&type=script&lang=js"
export * from "./TierItem.vue?vue&type=script&lang=js"

import "./TierItem.vue?vue&type=style&index=0&id=2a349916&lang=scss&scoped=true"

import exportComponent from "H:\\git\\Net_Web_LandingVue\\vue-code\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a349916"]])

export default __exports__